import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { ComProductSharedModel } from 'src/app/model/com-product-shared.model';
import { HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { ComProductSharedService } from 'src/oldApp/services/com-product-shared.service';
import { CreatorService } from 'src/app/services/creator.service';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { ModalScProductSharedComponent } from 'src/oldApp/shared/modal-sc-product-shared/modal-sc-product-shared.component';

@Component({
  selector: 'app-sc-product-shared',
  templateUrl: './sc-product-shared.component.html',
  styleUrls: ['./sc-product-shared.component.css']
})
export class ScProductSharedComponent implements OnInit {
  // estado pagina
  public page:string='ScCategoryPromoter';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public products:ComProductSharedModel[]=[];

  // catalogos
  public employeeJobCatalog:CatEmployeeJobModel[]=[];
  public productCatalog:HMGenericCatalog[]=[];
  public groupCollectCatalog:any=[
    {id:1, description:'GRUPO 1'},
    {id:2, description:'GRUPO 2'}
  ];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private comProductSharedService:ComProductSharedService,
    private catEmployeeJobService:CatEmployeeJobService,
    private hypermatrixCatalogsService:HypermatrixCatalogsService,
    private creator:CreatorService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  add=()=> {
    let product=this.creator.newComProductSharedModel();
    product.minCollect = null;
    let modalRef=this.modalService.open(ModalScProductSharedComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.product=product;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(product:ComProductSharedModel)=> {
    let modalRef=this.modalService.open(ModalScProductSharedComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.product={...product};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // HELPERS
  employeeJob=item=> this.employeeJobCatalog.find(job=> job.employeeJobId===item.employeeJobId).description;
  product=item=> this.productCatalog.find(prod=> prod.idCatalogType===item.productosCOEId).description;
  groupCollect=item=> this.groupCollectCatalog.find(gr=> gr.id===item.groupCollectId).description;

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.comProductSharedService.getAll(),
      this.catEmployeeJobService.getAll(),
      this.hypermatrixCatalogsService.getCatalog('ProductosCOE')
    )
    .pipe(
      tap(([proSharedResp, empJobResp, proResp]:[any, any, any])=> {
        if(proSharedResp && empJobResp && proResp) {
          this.products=proSharedResp.data;
          this.employeeJobCatalog=empJobResp.data;
          this.productCatalog=proResp.data;
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos'));
      })
    )
    .subscribe();
  }
}